import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CategoriesList from './pages/CategoriesList';
import MenuItems from './pages/MenuItems';
import SubcategoriesList from './pages/SubcategoriesList';
import Chart from './pages/Chart';
import LanguageList from './pages/LanguagesList';
import { GlobalStyles } from './components/MainContainer';

function App() {
  return (
    <>     
 
    <Routes>
        <Route path='/cardapio/:menu' element={ <Home/> } />
        <Route path='/cardapio/:menu?' element={ <Home/> } />
        <Route path='/cardapio/:menu/languages' element={ <LanguageList/> } />
        <Route path='/cardapio/:menu/home' element={ <Home/> } />
        <Route path='/cardapio/:menu/categories' element={ <CategoriesList/> } />
        <Route path='/cardapio/:menu/categories/:category' element={ <MenuItems/> } />
        <Route path='/cardapio/:menu/categories/:category/subcategories' element={ <SubcategoriesList/> } />
        <Route path='/cardapio/:menu/categories/:category/subcategories/:subcategory' element={ <MenuItems/> } />
        <Route path='/cardapio/:menu/chart' element={ <Chart/> } />
      </Routes>    
    </>
  );
}

export default App;
